export const CATEGORIES = {
  VAT: { bg: "#E0F7FA", border: "#40C0E0", text: "#0077B0" },
  Payroll: { bg: "#E6F4FB", border: "#0090D0", text: "#103080" },
  Accounts: { bg: "#E8EAF6", border: "#103080", text: "#103080" },
  "Management Accounts": { bg: "#F0F5E1", border: "#8BAA2E", text: "#4E6315" },
  "Self Assessment": { bg: "#FDF3E1", border: "#D9A441", text: "#7A5410" },
  "Corporation Tax": { bg: "#EEF0FB", border: "#5B6CC9", text: "#2B3A8C" },
  Bookkeeping: { bg: "#E6F5EF", border: "#3FA27C", text: "#1D5E45" },
  Admin: { bg: "#FCE8EF", border: "#E46A93", text: "#9C2A53" },
  Marketing: { bg: "#F1EAFB", border: "#9B6FD8", text: "#5B3496" },
  Services: { bg: "#E3F6F1", border: "#2FB394", text: "#14705A" },
  HR: { bg: "#FFF0E3", border: "#F2994A", text: "#9A4F0E" },
  Other: { bg: "#F1F5F9", border: "#94A3B8", text: "#334155" },
};

export const catStyle = (c) => CATEGORIES[c] || CATEGORIES.Other;

export const PRIORITIES = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const FREQUENCIES = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "annually", label: "Annually" },
];

export const JOB_TEMPLATES = [
  { key: "vat", title: "VAT return", category: "VAT", frequency: "quarterly", duration_minutes: 180, lead_days: 14, priority: "high" },
  { key: "payroll", title: "Monthly payroll run", category: "Payroll", frequency: "monthly", duration_minutes: 60, lead_days: 5, priority: "high" },
  { key: "bookkeeping", title: "Bookkeeping reconciliation", category: "Bookkeeping", frequency: "monthly", duration_minutes: 120, lead_days: 7, priority: "medium" },
  { key: "accounts", title: "Year-end accounts", category: "Accounts", frequency: "annually", duration_minutes: 600, lead_days: 60, priority: "medium" },
  { key: "management_accounts", title: "Management accounts", category: "Management Accounts", frequency: "monthly", duration_minutes: 240, lead_days: 10, priority: "medium" },
  { key: "ct600", title: "Corporation Tax return (CT600)", category: "Corporation Tax", frequency: "annually", duration_minutes: 240, lead_days: 30, priority: "high" },
  { key: "sa", title: "Self Assessment return", category: "Self Assessment", frequency: "annually", duration_minutes: 180, lead_days: 30, priority: "medium" },
];
